import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getCompanyCase() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCasebuReportingUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCasebuReportingUser(page, limit,search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers${page ? `?page=${page}&limit=${limit}&search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCasebuReportingUserSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers${search ? `?search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getFollowingCasebyUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllFollowingCasebyUser(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers${page ? `?page=${page}&limit=${limit}&search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getFollowingCasebyUserSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers${search ? `?search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchCaseDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByCase/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCase(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCase/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createCase(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCase`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteCase(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCase/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllCaseByLead(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByLead/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCaseByContact(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByContact/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCaseByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByAccount/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    findAllCaseByLead,
    findAllCaseByContact,
    findAllCaseByAccount,
    getCasebuReportingUser,
    getFollowingCasebyUserSearch,
    getCasebuReportingUserSearch,
    getAllCasebuReportingUser,
    getAllFollowingCasebyUser,
    getCompanyCase,
    FetchCaseDetails,
    getFollowingCasebyUser,
    updateCase,
    deleteCase,
    createCase
}